import api from "@/api";

const hydrateModuleState = (state, payload) => {
  Object.entries(payload).forEach(([key, value]) => {
    state[key] = value
    if (value.access) {
      api.defaults.headers.common['Authorization'] = `Bearer ${value.access}`
    }
  })
}

const warmUpCache = (state, payload) => {
  Object.keys(payload).forEach(i => hydrateModuleState(state[i], payload[i]))
}

export default warmUpCache
